import { showGalleryStatusToast } from 'ts/client/gallery/galleryStandaloneToast';

/**
 * @ngdoc service
 * @name  sp.client.gallery.service:spToast
 *
 * @description
 * Helps show React toasts from Angular
 */
export default [
    function spToast() {
        return {
            toast: showGalleryStatusToast
        };
    }
];
